export const FAVORITES_SHOW_TOAST_DELAY = 300;
